import React from "react";
import PropTypes from 'prop-types';

const Down = props => (
  <svg className={props.className} width={props.width} height={props.height} viewBox="0 0 13 8">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-203.000000, -698.000000)" fillRule="nonzero" fill="#635963">
        <g transform="translate(-798.000000, 0.000000)">
          <g transform="translate(934.000000, 668.000000)">
            <g transform="translate(73.500000, 34.000000) rotate(-90.000000) translate(-73.500000, -34.000000) translate(69.000000, 27.000000)">
              <path d="M-1.72946883,4.71279946 L3.77052843,10.6786061 C4.14829695,11.0883689 4.78113438,11.1090704 5.18401041,10.7248444 C5.58688643,10.3406184 5.60724008,9.69696327 5.22947157,9.28720054 L-0.270525695,3.32139387 C-0.648294211,2.91163113 -1.28113165,2.89092955 -1.68400767,3.2751556 C-2.08688369,3.65938164 -2.10723735,4.30303673 -1.72946883,4.71279946 Z M5.22947157,10.6786061 L10.7294688,4.71279946 C11.1072373,4.30303673 11.0868837,3.65938164 10.6840077,3.2751556 C10.2811316,2.89092955 9.64829421,2.91163113 9.27052569,3.32139387 L3.77052843,9.28720054 C3.39275992,9.69696327 3.41311357,10.3406184 3.81598959,10.7248444 C4.21886562,11.1090704 4.85170305,11.0883689 5.22947157,10.6786061 Z" id="Combined-Shape" transform="translate(4.500000, 7.000000) scale(-1, 1) rotate(-90.000000) translate(-4.500000, -7.000000) "></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Down.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
}

Down.defaultProps = {
  width: 13,
  height: 8,
  className: ""
}

export default Down;



// WEBPACK FOOTER //
// ./src/components/svgs/Down.js